import React from 'react'
import { usePageView } from '@fs/zion-analytics'
import { LayoutBand, Paragraph, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import PWAHeader from '../Activities/PWAHeader'

const childSafetyParagraphs = [
  {
    key: 'child-safety-standards.intro',
    defaultText:
      'FamilySearch International has a zero-tolerance policy regarding Child Sexual Abuse Entities (CSAE) and Child Sexual Abuse Content (CSAC). We are committed to maintaining a safe environment for all users.',
  },
  {
    key: 'child-safety-standards.prohibition',
    defaultText:
      'Prohibition: Users are strictly prohibited from sharing, uploading, or promoting any content that depicts child sexual abuse or exploitation.',
  },
  {
    key: 'child-safety-standards.reporting',
    defaultText:
      'Reporting: If any such content is identified, it will be removed immediately, and the offending account will be permanently banned.',
  },
  {
    key: 'child-safety-standards.cooperation',
    defaultText:
      'Cooperation: Together By FamilySearch complies with all legal requirements and will report such activity to the appropriate law enforcement authorities.',
  },
  {
    key: 'child-safety-standards.how-to-report',
    defaultText:
      'How to Report: Users can report any suspected child safety violations directly within the app via the “Submit Feedback” menu item.',
  },
  {
    key: 'child-safety-standards.review-process',
    defaultText: 'Review Process: Once a report is submitted, our team will review the content.',
  },
  {
    key: 'child-safety-standards.immediate-action',
    defaultText:
      'Immediate Action: If a violation is confirmed, the content will be permanently removed, and the associated user account will be terminated immediately.',
  },
]

const ChildSafetyStandards = () => {
  const { t } = useTranslation()
  const initData = { page_detail: 'Child Safety Standards' }
  usePageView(initData)

  return (
    <LayoutBand maxWidth="xxs">
      <Separator size="xs" />
      <PWAHeader title={t('child-safety-standards.title', 'Child Safety Standards')} showBack />
      <Separator size="sm" />
      {childSafetyParagraphs.map(({ key, defaultText }) => (
        <Paragraph key={key}>{t(key, defaultText)}</Paragraph>
      ))}
    </LayoutBand>
  )
}

export default ChildSafetyStandards
